module.exports = __webpack_public_path__ + "img/logo-footer.88a8efa7.svg";